import { config } from 'utils/config';

export const ENDPOINT_PATH = '/v2/manfredite/offer-filter';
export const NEXT_API_URL = `${config.appUrl}/api${ENDPOINT_PATH}`;
export const API_BASE_URL = `${config.apiUrl}${ENDPOINT_PATH}`;
